VjsAdmin.CategorySelect = (() => {
    const init = (parent = document.querySelector('body')) => {
        const categorySelect = $('#category-select');
        if (categorySelect.hasClass('select2-hidden-accessible')) {
            return;
        }

        categorySelect.select2({
            placeholder: 'Select Category',
            theme: 'bootstrap4',
            dropdownParent: parent,
        });
    };

    return {
        init,
    };
})();
